// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {postAuditRecords} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const updateAuditRecords = () =>

    async (dispatch, getState) => {

        let auditUpdated;

        auditUpdated = false;

        dispatch(busyCounter.increaseBusyCounter());

        const audit = getState().tcsm.recordAudit.auditRecording;

        try {

            await postAuditRecords(audit);

            successAlertBar(translate('AUDIT_SUBMITTED_SUCCESSFULLY'));

            auditUpdated = true;

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

            if (auditUpdated) {

                dispatch(routerActions.push('/tcsm/audits'));

            }

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/action-creators/post-audit-records.js